import { useNavigate as useRRNavigate } from 'react-router';
import { isAbsoluteUrl, isAllowedNextUrl } from 'helpers/url';

export function useNextNavigate() {
  const navigate = useRRNavigate();

  return (urlOrPath: string) => {
    if (isAbsoluteUrl(urlOrPath)) {
      if (isAllowedNextUrl(urlOrPath)) {
        window.location.replace(urlOrPath);
      } else {
        void navigate('/');
      }
    } else {
      void navigate(urlOrPath);
    }
  };
}
